export default "__VITE_ASSET__DwZzefPa__"